export const COLORS = [
  { key: "W", name: "White", cls: "bg-amber-50 text-amber-950 border-amber-300" },
  { key: "U", name: "Blue", cls: "bg-sky-600 text-sky-50 border-sky-400" },
  { key: "B", name: "Black", cls: "bg-zinc-900 text-zinc-200 border-zinc-500" },
  { key: "R", name: "Red", cls: "bg-red-600 text-red-50 border-red-400" },
  { key: "G", name: "Green", cls: "bg-emerald-600 text-emerald-50 border-emerald-400" },
];
export const COLORLESS = { key: "C", name: "Colorless", cls: "bg-slate-500 text-slate-50 border-slate-300" };

export const RARITIES = ["common", "uncommon", "rare", "mythic", "special", "bonus"];
export const RARITY_CLS = {
  common: "text-slate-300 border-slate-600",
  uncommon: "text-slate-100 border-slate-300",
  rare: "text-amber-300 border-amber-500/70",
  mythic: "text-orange-400 border-orange-500/80",
  special: "text-violet-300 border-violet-500/70",
  bonus: "text-cyan-300 border-cyan-500/70",
};

export const LAYOUTS = [
  { value: "normal", label: "Normal" },
  { value: "token", label: "Token" },
  { value: "transform", label: "Transform (DFC)" },
  { value: "modal_dfc", label: "Modal DFC" },
  { value: "double_faced_token", label: "Double-faced token" },
  { value: "split", label: "Split" },
  { value: "flip", label: "Flip" },
  { value: "adventure", label: "Adventure" },
  { value: "saga", label: "Saga" },
  { value: "emblem", label: "Emblem" },
  { value: "meld", label: "Meld (DFC)" },
  { value: "reversible_card", label: "Reversible card" },
  { value: "class", label: "Class" },
  { value: "case", label: "Case" },
  { value: "prototype", label: "Prototype" },
  { value: "leveler", label: "Leveler" },
  { value: "mutate", label: "Mutate" },
  { value: "planar", label: "Planar (plane / phenomenon)" },
  { value: "scheme", label: "Scheme" },
  { value: "vanguard", label: "Vanguard" },
  { value: "augment", label: "Augment" },
  { value: "host", label: "Host" },
];
export const DFC_LAYOUTS = ["transform", "modal_dfc", "double_faced_token", "meld", "reversible_card"];
export const MULTI_FACE_LAYOUTS = [...DFC_LAYOUTS, "split", "flip", "adventure"];
export const VISIBILITIES = ["public", "unlisted", "private"];
export const layoutLabel = (v) => LAYOUTS.find((l) => l.value === v)?.label || v;

export const ROLE_BADGE = {
  site_owner: "bg-gradient-to-r from-amber-500/20 to-yellow-500/20 text-amber-300 border border-amber-500/60 shadow-[0_0_10px_rgba(245,158,11,0.2)]",
  head_administrator: "bg-fuchsia-950/80 text-fuchsia-300 border border-fuchsia-500/50",
  administrator: "bg-purple-950/80 text-purple-300 border border-purple-500/50",
  senior_moderator: "bg-indigo-950/80 text-indigo-300 border border-indigo-500/50",
  moderator: "bg-blue-950/80 text-blue-300 border border-blue-500/50",
  senior_reviewer: "bg-emerald-950/80 text-emerald-300 border border-emerald-500/50",
  application_reviewer: "bg-teal-950/80 text-teal-300 border border-teal-500/50",
  rules_reviewer: "bg-lime-950/80 text-lime-300 border border-lime-500/50",
  support_staff: "bg-cyan-950/80 text-cyan-300 border border-cyan-500/50",
  member: "bg-slate-800/80 text-slate-300 border border-slate-700",
};
export const ROLE_LABELS = {
  site_owner: "Owner",
  head_administrator: "Head Administrator",
  administrator: "Administrator",
  senior_moderator: "Senior Moderator",
  moderator: "Moderator",
  senior_reviewer: "Senior Reviewer",
  application_reviewer: "Application Reviewer",
  rules_reviewer: "Rules Reviewer",
  support_staff: "Support Staff",
  member: "Member",
};
export const JUDGE_LABELS = { level_1: "Level 1 Judge", level_2: "Level 2 Judge", level_3: "Level 3 Judge", senior: "Senior Judge" };
export const SUPERTYPES = ["Basic", "Legendary", "Ongoing", "Snow", "World", "Host", "Elite", "Token"];
export const CARD_TYPES = ["Kindred", "Tribal", "Enchantment", "Artifact", "Land", "Creature", "Battle", "Planeswalker", "Instant", "Sorcery"];
export const SPECIAL_CARD_TYPES = ["Plane", "Phenomenon", "Scheme", "Vanguard", "Conspiracy", "Dungeon", "Emblem", "Hero"];
const ALL_TYPES = [...CARD_TYPES, ...SPECIAL_CARD_TYPES];

export function parseTypeLine(tl) {
  const [left, ...rest] = (tl || "").split(/\s[\u2014-]\s/);
  const words = left.trim().split(/\s+/).filter(Boolean);
  return {
    supertypes: words.filter((w) => SUPERTYPES.includes(w)),
    types: words.filter((w) => ALL_TYPES.includes(w)),
    other: words.filter((w) => !SUPERTYPES.includes(w) && !ALL_TYPES.includes(w)).join(" "),
    subtypes: rest.join(" — "),
  };
}

export function composeTypeLine({ supertypes, types, other, subtypes }) {
  const left = [...SUPERTYPES.filter((s) => supertypes.includes(s)), ...ALL_TYPES.filter((t) => types.includes(t)), other.trim()].filter(Boolean).join(" ");
  return subtypes.trim() ? `${left} — ${subtypes.trim()}` : left;
}

export const manaSymbols = (cost) => (cost || "").match(/\{[^}]+\}/g)?.map((s) => s.slice(1, -1)) || [];

export const colorsFromCost = (...costs) => {
  const found = new Set();
  costs.forEach((c) => manaSymbols(c).forEach((s) => s.toUpperCase().split("/").forEach((p) => "WUBRG".includes(p) && p && found.add(p))));
  return "WUBRG".split("").filter((c) => found.has(c));
};

export const prettifyFilename = (name) =>
  name
    .replace(/\.[^.]+$/, "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (m) => m.toUpperCase());
